"use client";

import { Navigate } from "react-router-dom";
import * as myApi from "../../Api";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = myApi.checkUserActive();
  const loginPath = myApi.loginPath;

  if (!isAuthenticated) {
    // Redirect to login if not authenticated (token missing or user inactive)
    return <Navigate to={loginPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
